import Header from '~/components/Header';
import HeroSection from '~/components/HeroSection';
import WorkTogether from '~/components/WorkTogether';
import Portfolio from '~/components/Portfolio';
import Footer from '~/components/Footer';
import Toolbox from '~/components/Toolbox';
import CTA from '~/components/CTA';
import HerosJourneyTimeline from '~/components/HerosJourneyTimeline';


export default function Index() {
  return (
    <div
      className="flex flex-col min-h-screen bg-chalkboard bg-cover"
      style={{
        backgroundImage: "url('chalk-background.jpg')", // Chalkboard texture
        backgroundSize: "cover",
        backgroundAttachment: "fixed", // Ensures the background stays fixed as the user scrolls
      }}
    >
      <Header />
      <HeroSection />
      <WorkTogether />
      <HerosJourneyTimeline />
      <Portfolio />
      <Toolbox />
      <CTA />
      <Footer />
    </div>
  );
}
